import React from 'react';
import PropTypes from 'prop-types';
import { withPageContext } from '../../utils/PageContext/PageContext';

export function QuickAccessOptions(props) {
    const { value, onChange } = props;

    return value ? (
        <div className="odf-quick-access-button-container">
            <OptionsWithPageContext value={1} adults={value} onClick={onChange} />
            <OptionsWithPageContext value={2} adults={value} onClick={onChange} />
            <OptionsWithPageContext value={3} adults={value} onClick={onChange} />
        </div>
    ) : (<div />);
}

QuickAccessOptions.propTypes = {
    value: PropTypes.oneOfType([
        PropTypes.bool,
        PropTypes.number,
    ]).isRequired,
    onChange: PropTypes.func.isRequired,
};

export const Option = (props) => {
    const { onClick, value, adults, trackEvent } = props;
    const onClickOption = (e) => {
        e.stopPropagation();
        onClick(value);
        trackEvent({ action: 'searcher_flights', label: 'passenger_shortcut_' + value });
    };

    return (
        <span
            className={`odf-btn odf-btn-secondary odf-clickable odf-quick-access-button ${adults === value ? 'active' : '' }`}
            onClick={onClickOption}
        >
            {value}
        </span>
    );
};

Option.propTypes = {
    adults: PropTypes.number.isRequired,
    onClick: PropTypes.func.isRequired,
    value: PropTypes.number.isRequired,
    trackEvent: PropTypes.func.isRequired,
};

const OptionsWithPageContext = withPageContext(Option);
